import { Schema, z } from 'zod';

/**
 * Activation status of a definition.
 */
export type DefinitionStatusType = 'active' | 'inactive';

/**
 * Activation status of this zone definition.
 */

export enum DefinitionStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export const DefinitionStatusSchema: Schema<DefinitionStatusType> =
  z.nativeEnum(DefinitionStatus);

/** States representing the lifecycle of a module. */
export type ConfigurationStatusType =
  | 'draft'
  | 'staged'
  | 'published'
  | 'unpublished'
  | 'deleted'
  | 'revision';

export enum ConfigurationStatus {
  Draft = 'draft',
  Staged = 'staged',
  Published = 'published',
  Unpublished = 'unpublished',
  Deleted = 'deleted',
  Revision = 'revision'
}

export const ConfigurationStatusSchema: Schema<ConfigurationStatusType> =
  z.nativeEnum(ConfigurationStatus);
